<div>
	<div class="flex items-center">
		<app-icon [icon]="ICON.PARTIES" class="text-2xl"></app-icon>
		<h2 class="text-2xl ml-3">Contacts</h2>
	</div>
</div>

<section class="mt-5">
	<h4 class="contacts__header">
		<app-anchor class="text-grey-darker" [url]="clientsUrl">Clients</app-anchor>
	</h4>

	<ng-container *ngIf="clients$ | async as clients">
		<div [ngClass]="getContainerCSSClass(clients.length)">
			<ng-container *ngFor="let client of clients; trackBy: trackByClientId">
				<app-member-card
					[firstName]="client?.firstName"
					[lastName]="client?.lastName"
					class="flex-1 mr-2"
					[clientType]="client?.type"
					[badgeIcon]="client?.name ? ICON.BUSINESS : null"
					[name]="client?.name"
					[email]="client?.email"
					[phone]="client?.phone"
					(dropdown)="clientKebebSelect($event, client.id)"
					[menuItems]="contactCardDropdownItems"
					[testHook]="testHooks.ClientsMemberCard"
				>
				</app-member-card>
			</ng-container>
		</div>
	</ng-container>
</section>

<div class="mt-7" *ngIf="showOtherPartyCardsOverview$ | async">
	<h4>Other parties</h4>
	<ng-container *ngIf="otherParties$ | async as clients">
		<div [ngClass]="getContainerCSSClass(clients.length)">
			<ng-container *ngFor="let client of clients; trackBy: trackByClientId">
				<app-member-card
					[firstName]="client?.firstName"
					[lastName]="client?.lastName"
					class="flex-1 mr-2"
					[clientType]="client?.type"
					[badgeIcon]="client?.name ? ICON.BUSINESS : null"
					[name]="client?.name"
					[email]="client?.email"
					[phone]="client?.phone"
					(dropdown)="clientKebebSelect($event, client.id)"
					[menuItems]="contactCardDropdownItems"
					[testHook]="testHooks.OtherPartyClientCard"
				>
				</app-member-card>
			</ng-container>
		</div>
	</ng-container>
	<ng-container *ngIf="lawFirm$ | async as lawFirm">
		<div [ngClass]="getContainerCSSClass(getLawyerAndClerkCount(lawFirm))">
			<app-member-card
				(dropdown)="clientKebebSelectLawfirm($event, 'lawyer')"
				[menuItems]="contactCardLawfirmDropdownItems"
				*ngIf="lawFirm.lawyer"
				[ccEmail]="lawFirm.clerk?.email"
				[member]="lawFirm.name"
				memberType="Lawyer"
				[firstName]="lawFirm.lawyer?.firstName"
				[lastName]="lawFirm.lawyer?.lastName"
				[email]="lawFirm.lawyer?.email"
				[phone]="lawFirm.lawyer?.phoneNumber"
				[testHook]="testHooks.OtherPartyLawyerCard"
			></app-member-card>
			<app-member-card
				(dropdown)="clientKebebSelectLawfirm($event, 'clerk')"
				[menuItems]="contactCardLawfirmDropdownItems"
				*ngIf="lawFirm.clerk"
				[ccEmail]="lawFirm.lawyer?.email"
				[member]="lawFirm.name"
				memberType="Clerk"
				[firstName]="lawFirm.clerk?.firstName"
				[lastName]="lawFirm.clerk?.lastName"
				[email]="lawFirm.clerk?.email"
				[phone]="lawFirm.clerk?.phoneNumber"
				[testHook]="testHooks.OtherPartyClerkCard"
			></app-member-card>
		</div>
	</ng-container>
</div>
